<ion-header>
  <ind-page-title [viewData]="pageTitleViewData" (onControlClick)='onPageTitleControlClick($event)'></ind-page-title>
  <div class="searchbar-wrapper">
    <ion-searchbar placeholder="{{searchPlaceholder}}" [(ngModel)]="searchInput" (ionInput)="handleSearch()"></ion-searchbar>
    <div class="searchbar-overlay">
      <ion-button tooltip="{{'FILTERS' | translate}}" class="searchbar-overlay-button" fill="clear" *ngIf="searchFilterEnabled" (click)="onFilterClick($event)">
        <ion-icon class="searchbar-overlay-button-filter-icon contactTimelineFilterIcon" slot="icon-only" src="assets/imgs/header_filter.svg" [class.timeline-filter-empty]="_allTimelineActivities.length == 0"></ion-icon>
        <span *ngIf="filterButtonBadgeCount > 0" class="searchbar-filter-badge">{{ filterButtonBadgeCount }}</span>
      </ion-button>
    </div>
  </div>
  <!--Account Glance Card-->
  <glance-card *ngIf="accountGlanceViewData" [viewData]="accountGlanceViewData"
    [quickActions]="accountQuickActions" [hasQuickActionOverflow]="hasQuickActionOverflow"
    (onControlClick)="onQuickGlanceControlClick($event)"
    (quickActionOverflow)="openQuickActionOverflow($event)"> </glance-card>
</ion-header>

<ion-content>

  <ind-section-header *ngIf="timelineSectionHeader" [viewData]='timelineSectionHeader'></ind-section-header>
  <cdk-virtual-scroll-viewport *ngIf="timelineItems.length > 0 && accountOfflineService.isAccountTimelineLoaded$ | async" itemSize="56" class="viewport">
    <ion-list class="time-line-list">
      <timeline-item *cdkVirtualFor="let item of timelineItems" [inputData]="item"
        (clickedOnHeader)="openActivityDetails($event)"
        (clickedOnPopupImage)="openDyanmicURl(item.refObject)"></timeline-item>
    </ion-list>
  </cdk-virtual-scroll-viewport>
  <ion-infinite-scroll threshold="30%" (ionInfinite)="from === 'timeline' ? loadMore($event) : doInfinite($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
  <ion-list *ngIf="timelineItems.length == 0 && accountOfflineService.isAccountTimelineLoaded$ | async">
    <div class="no-data-message">
      {{'NO_ACTIVITIES_CAP' | translate}}</div>
  </ion-list>

</ion-content>
